export const SolutionVisibility = {
  PUBLIC: "Public",
  PRIVATE: "Private"
};

export default SolutionVisibility;
